import { render, staticRenderFns } from "./SmartPagination.vue?vue&type=template&id=fb78a548&scoped=true"
import script from "./SmartPagination.vue?vue&type=script&lang=js"
export * from "./SmartPagination.vue?vue&type=script&lang=js"
import style0 from "./SmartPagination.vue?vue&type=style&index=0&id=fb78a548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb78a548",
  null
  
)

export default component.exports